/* -----------------Globals--------------- */
import { Pressable } from "react-native";

import Icon from "@react-native-vector-icons/material-design-icons/static";
import { useTranslation } from "react-i18next";
/* -----------------UI--------------- */
import { Text } from "react-native-paper";

import { useAppTheme } from "../../../useAppTheme";
import { AppIcon } from "../..//AppIcon";
/* -----------------Child components--------------- */
import Box from "../../Box";
import { COMMAND_BAR_TRIGGER_ID } from "./constants";
import { useToggleCommandbar } from "./useToggleCommandbar";

type Props = {
	handleTrackEvent: () => void;
};

const CommandbarContainer = ({ handleTrackEvent }: Props) => {
	const { t } = useTranslation();
	const toggleCommandbar = useToggleCommandbar();
	const theme = useAppTheme();

	const handlePress = () => {
		handleTrackEvent();
		toggleCommandbar();

		const activeElement = document.activeElement;
		if (activeElement instanceof HTMLElement) {
			activeElement.blur();
		}
	};

	return (
		<Pressable
			nativeID={COMMAND_BAR_TRIGGER_ID}
			onPress={handlePress}
			accessibilityRole="button"
			accessibilityLabel="Search"
			accessibilityHint="Activate to open the command palette and search"
			style={{
				cursor: "pointer",
			}}
		>
			<Box
				flexDirection="row"
				alignItems="center"
				gap={8}
				height={42}
				minWidth={360}
				borderRadius={28}
				paddingHorizontal={16}
				backgroundColor={theme.colors.background}
			>
				<AppIcon
					name="magnify"
					size={20}
					color={theme.colors.onSurfaceVariant}
				/>
				<Text
					variant="bodyLarge"
					style={{
						flex: 1,
						color: theme.colors.onSurfaceVariant,
					}}
				>
					{t("commandBar.placeholder")}
				</Text>
				<Box flexDirection="row" alignItems="center" gap={4}>
					<Icon
						color={theme.colors.onSurfaceVariant}
						name="apple-keyboard-command"
						size={16}
					/>
					<Text
						style={{
							color: theme.colors.onSurfaceVariant,
						}}
						variant="labelLarge"
					>
						K
					</Text>
				</Box>
			</Box>
		</Pressable>
	);
};

export default CommandbarContainer;
